import { render, staticRenderFns } from "./Datos_generales.vue?vue&type=template&id=7c4be5ab"
import script from "./Datos_generales.vue?vue&type=script&lang=js"
export * from "./Datos_generales.vue?vue&type=script&lang=js"
import style0 from "./Datos_generales.vue?vue&type=style&index=0&id=7c4be5ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports